import { put, takeEvery } from "redux-saga/effects";

import { getRateFailure, getRateSuccess } from "./actions";
import { getRateActionTypes } from "./actionTypes";

//TODO uncomment when MATIC is back

// const getRateAsync = ({ MoralisService }) => {
//   if (!MoralisService) {
//     console.log("Required services does not exist");

//     return;
//   }

//   return MoralisService.getExchangeRate();
// };

function* getRate() {
  try {
    // const { MoralisService } = yield getContext(CONTEXT.SERVICES);

    // const { usdPrice } = yield call(getRateAsync, {
    //   MoralisService,
    // });

    yield put(getRateSuccess({ usdPrice: 1 }));
  } catch ({ error }) {
    yield put(getRateFailure(error));
  }
}

export function* watchGetRate() {
  yield takeEvery(getRateActionTypes.request, getRate);
}
